<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{data.isEdit ? 'Edit' : 'Add'}} Lab Process Monitoring  {{text}}
  </div>
  <button mat-icon-button class="close-btn" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div class="header-section">
    <table style="text-align:center; margin: 0 auto;"  class="header-table">
      <tr>
        <td style="text-align: left;"><b>Name:</b></td>
        <td style="text-align: left;">{{data.userName}}</td>
        <td style="text-align: left;"><b>Site Name:</b></td>
        <td style="text-align: left;">{{data.siteName}}</td>
      </tr>
      <tr>
        <td style="text-align: left;"><b>Sample Date:</b></td>
        <td>
          <mat-form-field appearance="outline" style="width:100%;">
            <input matInput [matDatepicker]="picker" [(ngModel)]="data.dateCaptured" #dcctrl="ngModel" required [disabled]="data.isEdit"
              placeholder="Choose a date" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="dcctrl.invalid">Date is required</mat-error>
          </mat-form-field>
        </td>
        <td style="text-align: left;"><b>Report Date:</b></td>
        <td>
          <mat-form-field appearance="outline" style="width:100%;">
            <input matInput [matDatepicker]="rdpicker" [(ngModel)]="data.reportDate" #rdctrl="ngModel" required [disabled]="data.isEdit"
              placeholder="Choose a date" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
            <mat-datepicker-toggle matSuffix [for]="rdpicker"></mat-datepicker-toggle>
            <mat-datepicker #rdpicker></mat-datepicker>
            <mat-error *ngIf="rdctrl.invalid">Date is required</mat-error>
          </mat-form-field>
        </td>
      </tr>
      <tr>
        <td style="text-align: left;"><b>Lab:</b></td>
        <td>          
          <mat-form-field appearance="outline" style="width:100%;">
            <mat-label>Lab</mat-label>
            <mat-select [(ngModel)]="data.labDataId" data-testid="labDataId" name="labDataId">
              <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                <input #siteSearchInput matInput placeholder="Search Lab data..." (input)="filterLabData($event)"
                  class="mat-select-search-input" aria-label="Search Lab data" (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation();" />
                <mat-icon class="mat-select-search-icon">search</mat-icon>
              </div>
              <mat-option [value]="null">-Select Lab-</mat-option>
              <mat-option *ngFor="let lab of filteredLabTypes" [value]="lab.id">
                {{ lab.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
        <td>
          <b>Lab Report Id:</b>
        </td>
        <td>
          <mat-form-field appearance="outline" style="width:100%;">
            <mat-label>Lab Report ID</mat-label>
            <input matInput type="text" placeholder="Enter Lab Report ID" [(ngModel)]="data.labReportId" maxlength="15">
          </mat-form-field>
        </td>
      </tr>
    </table>
  </div>

  <form [formGroup]="ldcForm">
    <mat-tab-group class="flex-grow" animationDuration="0ms" [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="selectedTabIndex.set($event)">
      <ng-container *ngIf="tabs.length > 0 && tanksFormArray.length > 0">
        <div formArrayName="tanks">
          <mat-tab *ngFor="let tab of tabs; let rowIndex = index" [label]="tab.tankName">
            <div [formGroupName]="rowIndex" class="tab-content">
              <div class="form-grid" style="padding-top: 6px;">
                
                <!-- Row 1: Cod and Total Solids, volatile solids -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>COD (Chemical Oxygen Demand) (mg/L)</mat-label>
                    <input matInput type="text" formControlName="cod"
                      (input)="roundOffDynamic($event, rowIndex, 'cod', 999999999, 2)"
                      placeholder="Enter COD (mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Total Solids (%)</mat-label>
                    <input matInput type="text" formControlName="total_solids"
                      (input)="roundOffDynamic($event, rowIndex, 'total_solids', 999999999, 2)"
                      placeholder="Enter Total Solids (%)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Total Volatile Solids (%)</mat-label>
                    <input matInput type="text" formControlName="volatile_solids"
                      (input)="roundOffDynamic($event, rowIndex, 'volatile_solids', 999999999, 2)"
                      placeholder="Enter Volatile Solids" />
                  </mat-form-field>
                </div>

                <!-- Row 2: Ammonia, sulfate, pH -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>Total Ammonia (mg/L)</mat-label>
                    <input matInput type="text" formControlName="ammonia"
                      (input)="roundOffDynamic($event, rowIndex, 'ammonia', 999999999, 2)"
                      placeholder="Enter Ammonia" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Sulfate (mg/L)</mat-label>
                    <input matInput type="text" formControlName="sulfate"
                      (input)="roundOffDynamic($event, rowIndex, 'sulfate', 999999999, 2)"
                      placeholder="Enter Sulfate(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>pH</mat-label>
                    <input matInput type="text" formControlName="pH"
                      (input)="roundOffDynamic($event, rowIndex, 'pH', 9, 1)"
                      placeholder="Enter pH" />
                  </mat-form-field>
                </div>

                <!-- Row 3: TIC, VFA, VFA by TIC -->
                <div class="form-grid-row">
                  <!-- <mat-form-field appearance="outline">
                    <mat-label>COD Outlet</mat-label>
                    <input matInput type="text" formControlName="coD_outlet"
                      (input)="roundOffDynamic($event, rowIndex, 'coD_outlet', 999999999, 2)"
                      placeholder="Enter COD Outlet" />
                  </mat-form-field> -->
                  <mat-form-field appearance="outline">
                    <mat-label>TIC (Total Inorganic Carbon)</mat-label>
                    <input matInput type="text" formControlName="tic"
                      (input)="roundOffDynamic($event, rowIndex, 'tic', 999999999, 2)"
                      placeholder="Enter TIC" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Total VFA (Volatile Fatty Acids) (mg/L)</mat-label>
                    <input matInput type="text" formControlName="vfa"
                      (input)="roundOffDynamic($event, rowIndex, 'vfa', 999999999, 2)"
                      placeholder="Enter VFA (mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>VFA by TIC</mat-label>
                    <input matInput type="text" formControlName="vfaByTIC"
                      (input)="roundOffDynamic($event, rowIndex, 'vfaByTIC', 999999999, 2)"
                      placeholder="Enter VFA by TIC" />
                  </mat-form-field>

                </div>

                <!-- Row 4: acetic, propionic Butyric-->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>VFA - Acetic(mg/L)</mat-label>
                    <input matInput type="text" formControlName="vfA_Acetic"
                      (input)="roundOffDynamic($event, rowIndex, 'vfA_Acetic', 999999999, 2)"
                      placeholder="Enter VFA Acetic(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>VFA - Propionic(mg/L)</mat-label>
                    <input matInput type="text" formControlName="vfA_ropionic"
                      (input)="roundOffDynamic($event, rowIndex, 'vfA_ropionic', 999999999, 2)"
                      placeholder="Enter VFA Propionic(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>VFA - Butyric(mg/L)</mat-label>
                    <input matInput type="text" formControlName="vfA_Butyric"
                      (input)="roundOffDynamic($event, rowIndex, 'vfA_Butyric', 999999999, 2)"
                      placeholder="Enter VFA Butyric(mg/L)" />
                  </mat-form-field>
                </div>

                <!-- Row 5: valeric tkn, sulfur -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>VFA - Valeric(mg/L)</mat-label>
                    <input matInput type="text" formControlName="vfA_Valeric"
                      (input)="roundOffDynamic($event, rowIndex, 'vfA_Valeric', 999999999, 2)"
                      placeholder="Enter VFA Valeric(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>TKN (Total Kjeldahl Nitrogen)(mg/L)</mat-label>
                    <input matInput
                      type="text"
                      formControlName="tkn"
                      (input)="roundOffDynamic($event, rowIndex, 'tkn', 999999999, 2)"
                      placeholder="Enter TKN(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Total Sulfur(mg/L)</mat-label>
                    <input matInput type="text" formControlName="dissolved_sulfur"
                      (input)="roundOffDynamic($event, rowIndex, 'dissolved_sulfur', 999999999, 2)"
                      placeholder="Enter Total Sulfur(mg/L)" />
                  </mat-form-field>
                </div>

                <!-- Row 6: Chloriges, Organic Carbon, Phosphorus -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>Chlorides (mg/L)</mat-label>
                    <input matInput type="text" formControlName="chlorides"
                      (input)="roundOffDynamic($event, rowIndex, 'chlorides', 999999999, 2)"
                      placeholder="Enter chlorides(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Total Organic Carbon(mg/L)</mat-label>
                    <input matInput type="text" formControlName="totalOrganicCarbon"
                      (input)="roundOffDynamic($event, rowIndex, 'totalOrganicCarbon', 999999999, 2)"
                      placeholder="Enter Total Organic Carbon(mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Phosphorus (mg/L)</mat-label>
                    <input matInput type="text" formControlName="phosphorus"
                      (input)="roundOffDynamic($event, rowIndex, 'phosphorus', 999999999, 2)"
                      placeholder="Enter Phosphorus (mg/L)" />
                  </mat-form-field>
                </div>

                <!-- Row 7: Potassium, Oil, Iron -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>Potassium (mg/L)</mat-label>
                    <input matInput type="text" formControlName="potassium"
                      (input)="roundOffDynamic($event, rowIndex, 'potassium', 999999999, 2)"
                      placeholder="Enter Potassium (mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Oil and Grease (HEM) (mg/L)</mat-label>
                    <input matInput type="text" formControlName="oilandGrease"
                      (input)="roundOffDynamic($event, rowIndex, 'oilandGrease', 999999999, 2)"
                      placeholder="Enter Oil and Grease (HEM) (mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Iron (mg/L)</mat-label>
                    <input matInput type="text" formControlName="iron"
                      (input)="roundOffDynamic($event, rowIndex, 'iron', 999999999, 2)"
                      placeholder="Enter Iron (mg/L)" />
                  </mat-form-field>
                </div>

                <!-- Row 8: Isovalerix succinic, caproic -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>VFA - Isovaleric (mg/L)</mat-label>
                    <input matInput type="text" formControlName="vFAIsovaleric"
                      (input)="roundOffDynamic($event, rowIndex, 'vFAIsovaleric', 999999999, 2)"
                      placeholder="Enter VFA - Isovaleric (mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label> VFA - Succinic (mg/L)</mat-label>
                    <input matInput type="text" formControlName="vFASuccinic"
                      (input)="roundOffDynamic($event, rowIndex, 'vFASuccinic', 999999999, 2)"
                      placeholder="Enter  VFA - Succinic (mg/L)" />
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label> VFA - Caproic (mg/L)</mat-label>
                    <input matInput type="text" formControlName="vFACaproic"
                      (input)="roundOffDynamic($event, rowIndex, 'vFACaproic', 999999999, 2)"
                      placeholder="Enter  VFA - Caproic (mg/L)" />
                  </mat-form-field>
                </div>
                <!-- Row 9: Lactic -->
                <div class="form-grid-row">
                  <mat-form-field appearance="outline">
                    <mat-label>VFA - Lactic (mg/L)</mat-label>
                    <input matInput type="text" formControlName="vFALactic"
                      (input)="roundOffDynamic($event, rowIndex, 'vFALactic', 999999999, 2)"
                      placeholder="Enter  VFA - Lactic (mg/L)" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-tab>
        </div>
      </ng-container>
    </mat-tab-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
  @if(canShowSaveButton()) {
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  }
</mat-dialog-actions>
